// Features type 12 layout styles
.features-type-12--centered {
  text-align: center;
}

.features-type-12__cards {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-4xl);

  @include above(960px) {
    flex-direction: row;
  }

  > * {
    flex: 1 1 0;
    min-width: 0;
  }
}

// Features card type 5 styles
.features-card-type-5 {
  background-color: var(--background-color-brand-primary-lightest);
  padding: var(--spacing-2xl);
  border-radius: var(--radius-size-lg);
  align-self: stretch;
  height: 100%;

  @include above(1024px) {
    padding: var(--spacing-4xl);
  }
}

.features-card-type-5__icon {
  margin-bottom: var(--spacing-xl);

  .me-icon {
    min-width: 48px;

    svg {
      path {
        fill: var(--color-brand-primary-main);
      }
    }
  }
}

// Theme-specific styles
.theme-brand-signnow {
  .me-heading a {
    text-decoration: none;
    transition: color 0.3s ease;

    &:hover {
      color: $color-brand-primary-main;
    }
  }
}
